import React, { useEffect, useState, useContext, useRef } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../../AuthContext";
import PageServices from "../../services/PageServices";
import CommonServices from '../../services/ComanServices';
import useAsync from '../../hooks/useAsync';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Bar,
  BarChart,
  Cell,
  ResponsiveContainer,
  Area,
  AreaChart
} from "recharts";
import { set } from "date-fns";

// import { Bar } from 'recharts';

// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);


function Optionchain({ searchValue, onTradingChange, onTradingChangetwo }) {
  const [data, setData] = useState([]);

  const { isLoggedIn, logout } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [processedData, setProcessedData] = useState([]);
  const [selectedStrikePrice, setSelectedStrikePrice] = useState(null);
  const [greekChainData, setGreekChainData] = useState([]);
  const [intraDay, setIntraDay] = useState('')
  const [chartData, setChartData] = useState([]);
  const [spotPrice, setSpotPrice] = useState(0);
  const [highestCEOIChange, setHighestCEOIChange] = useState(0);
  const [secondHighestCEOIChange, setSecondHighestCEOIChange] = useState(0);
  const [thirdHighestCEOIChange, setThirdHighestCEOIChange] = useState(0);

  const [highestCEOI, setHighestCEOI] = useState(0);
  const [secondHighestCEOI, setSecondHighestCEOI] = useState(0);
  const [thirdHighestCEOI, setThirdHighestCEOI] = useState(0);

  const [highestCEVolume, setHighestCEVolume] = useState(0);
  const [secondHighestCEVolume, setSecondHighestCEVolume] = useState(0);
  const [thirdHighestCEVolume, setThirdHighestCEVolume] = useState(0);
  const [highestPEOIChange, setHighestPEOIChange] = useState(0);
  const [secondHighestPEOIChange, setSecondHighestPEOIChange] = useState(0);
  const [thirdHighestPEOIChange, setThirdHighestPEOIChange] = useState(0);
  const [highestPEOI, setHighestPEOI] = useState(0);
  const [secondHighestPEOI, setSecondHighestPEOI] = useState(0);
  const [thirdHighestPEOI, setThirdHighestPEOI] = useState(0);
  const [highestPEVolume, setHighestPEVolume] = useState(0);
  const [secondHighestPEVolume, setSecondHighestPEVolume] = useState(0);
  const [thirdHighestPEVolume, setThirdHighestPEVolume] = useState(0);

  const [resistanceLevel, setResistanceLevel] = useState(null);
  const [supportLevel, setSupportLevel] = useState(null);
  const [futurePrice, setFutrePrice] = useState(0);
  const [previousHistory, setPreviousHistory] = useState([]);
  const [support, setSupport] = useState(0);
  const [resistance, setResistance] = useState(0);
  const [support2, setSupport2] = useState(0);
  const [resistance2, setResistance2] = useState(0);

  const [futureSupport, setFutureSupport] = useState(0);
  const [futureResistance, setFutureResistance] = useState(0);
  const [futureSupport2, setFutureSupport2] = useState(0);
  const [futureResistance2, setFutureResistance2] = useState(0);
  const [date, setDate] = useState(0);
  const [weeklyUpper, setWeeklyUpper] = useState(0);
  const [weeklyDown, setWeeklyDown] = useState(0);
  const [day, setDay] = useState(null);
  const [firstOptionChain, setFirstOptionChain] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedGreek, setSelectedGreek] = useState('');

// console.log("selectedGreek",selectedGreek);
  const toggleDropdown = () => {
    setOpen(!open);
  };

  const styles = {
    dropdown: {
      position: 'relative',
      display: 'inline-block',
    },

    dropbtn: {
      backgroundColor: '#f77c22',
      color: 'white',
      padding: '8px 16px',
      fontSize: '16px',
      border: 'none',
      borderRadius: '8px',
      cursor: 'pointer',
      marginBottom: '10px',
    },
    dropdownContent: {
      position: 'absolute',
      backgroundColor: '#f77c22',
      minWidth: '160px',
      boxShadow: '0px 8px 16px rgba(0,0,0,0.2)',
      borderRadius: '8px',
      overflow: 'hidden',
      zIndex: 1,
      marginTop: '5px',
    },
    dropdownItem: {
      color: 'white',
      padding: '12px 16px',
      textDecoration: 'none',
      display: 'block',
      textAlign: 'center',
      fontWeight: 'bold',
      borderBottom: '1px solid white',
      cursor: 'pointer',
    },
    lastItem: {
      borderBottom: 'none',
    },
    hoverItem: {
      backgroundColor: '#e46c15',
    }
  };
  const [selectedGreeks, setSelectedGreeks] = useState([]);
  const greekitems = ['GAMMA', 'VEGA', 'THETA', 'DELTA', 'RESET'];
  const handleGreekSelect = (item) => {
    if (item === 'RESET') {
      setSelectedGreeks([]); // clear all on reset
    } else if (!selectedGreeks.includes(item)) {
      setSelectedGreeks(prev => [...prev, item]); // add only if not already selected
    }
    toggleDropdown();
  };
  const [activeButtons, setActiveButtons] = useState([]);

  const toggleButton = (buttonName) => {
    if (activeButtons.includes(buttonName)) {
      setActiveButtons(activeButtons.filter(name => name !== buttonName)); // remove button
    } else {
      setActiveButtons([...activeButtons, buttonName]); // add button
    }
  };

  useEffect(() => {
    const fetchDay = async () => {
      try {
        const response = await CommonServices.getDay();
        const dayData = response.data;
        setDay(dayData);

        const price = spotPrice; // aapka actual price yahan set karo
        const X = Math.sqrt(365 / dayData.weeklyDay);  // root nikal diya
        const Y = dayData.indiaVix;
        const Z = Y / X;  // Y divided by X

        const down = price - (price * Z / 100);
        const upper = price + (price * Z / 100);

        setWeeklyDown(down);
        setWeeklyUpper(upper);

      } catch (err) {
        console.error("Error fetching day data:", err);
      }
    };

    fetchDay();
  }, [spotPrice]);

  const [rangeStart, setRangeStart] = useState('');
  const [rangeEnd, setRangeEnd] = useState('');
  const [rangeOptions, setRangeOptions] = useState([]);
  const [callOI, setCallOI] = useState(0);
  const [putOI, setPutOI] = useState(0);
  const [callOIChange, setCallOIChange] = useState(0);  
  const [putOIChange, setPutOIChange] = useState(0);
  const [dataCallPutOIChange, setDataCallPutOIChange] = useState([]);
  const [dataCallPutOI, setDataCallPutOI] = useState([]);
  const isInitialRangeSet = useRef(false);  
  useEffect(() => {
    if (data && data.length > 0) {
      const prices = data.map(item => item.strikePrice);
      setRangeOptions(prices);
  
      if (!isInitialRangeSet.current) {
        setRangeStart(prices[0]);
        setRangeEnd(prices[prices.length - 1]);
        isInitialRangeSet.current = true; // Mark as initialized
      }
    }
  }, [data]);


  useEffect(() => {
    calculateOpenInterestChange();
  }, [rangeStart, rangeEnd, data]);
  
  const calculateOpenInterestChange = () => {
    if (!data || data.length === 0) return;
  
    // Filter kar rahe strike prices ke range ke andar
    const filteredData = data.filter(item => {
      const strike = parseFloat(item.strikePrice);
      return strike >= parseFloat(rangeStart) && strike <= parseFloat(rangeEnd);
    });
  
    // CE and PE OpenInterestChange ka total
    let totalCallOIChange = 0;
    let totalPutOIChange = 0;
    let totalCallOI = 0;
    let totalPutOI = 0;
  
    filteredData.forEach(item => {
      if (item.CE) {
        totalCallOIChange += item.CE.OpenInterestChange || 0;
        totalCallOI += item.CE.OpenInterest || 0;
      }
      if (item.PE) {
        totalPutOIChange += item.PE.OpenInterestChange || 0;
        totalPutOI += item.PE.OpenInterest || 0;
      }
    });
  
    setCallOIChange(totalCallOIChange / 100000); 
    setPutOIChange(totalPutOIChange / 100000);
    setCallOI(totalCallOI / 100000); 
    setPutOI(totalPutOI / 100000);


    
  
    setDataCallPutOIChange([
      { name: "CALL", value: totalCallOIChange / 1000 },
      { name: "PUT", value: totalPutOIChange / 1000 }
    ]);
    setDataCallPutOI([
      { name: "CALL", value: totalCallOI / 1000 },
      { name: "PUT", value: totalPutOI / 1000 }
    ]);
  };

  

// If you're fetching data, adjust this dependency array
  
  // console.log("day", day);
  // console.log("WeeklyUpper", weeklyUpper);
  // console.log("WeeklyDown", weeklyDown);
  const fetchData = async () => {
    try {

      // count ema 
      function calculateEMA(values, period = 3) {
        let ema = values[2]?.Low; // Start with the first value as the initial EMA
        const smoothingFactor = 2 / (period + 1); // Smoothing factor (multiplier)

        for (let i = 1; i >= 0; i--) {
          ema = (smoothingFactor * values[i].Low) + ((1 - smoothingFactor) * ema);
        }

        return ema;
      }
      let response

      if (localStorage.getItem("stock") === "GOLD" || localStorage.getItem("stock") === "SILVER" || localStorage.getItem('stock') === 'CRUDEOIL' || localStorage.getItem("stock") === "COPPER" || localStorage.getItem("stock") === "NATURALGAS") {

        response = await PageServices.getComodityOptionChain({
          symbolToken: localStorage.getItem("stock"),
        });
        // console.log(">>>>>>>>>res1", response);
      } else {

        response = await PageServices.getOptionChain({
          symbolToken: localStorage.getItem("stock"),
        });
        response.formattedData.sort((x, y) => parseFloat(x.strikePrice) - parseFloat(y.strikePrice));
        // console.log(">>>>>>>>>res123",res123);
      }


      PageServices.getDataForSuportandRessitans(localStorage.getItem("stock")).then((response) => {
        setFirstOptionChain(response);
        //  console.log(response);
      }).catch((error) => {
        console.error('Error fetching data for support and ressitance:', error);
      });

      // Ensure response.sub and response.future exist before accessing them
      setSpotPrice(response?.spotPrice?.LastTradePrice ?? 0);
      setFutrePrice(response?.futurePrice?.LastTradePrice ?? 0);
      onTradingChange(response?.historical);
      setPreviousHistory(response?.historical);
      const currentDate = new Date();

      // Extract the components from the date
      const month = currentDate.toLocaleString('default', { month: 'short' });  // Short month name (e.g., "Dec")
      const day = String(currentDate.getDate()).padStart(2, '0');  // Day with leading zero if necessary
      const year = currentDate.getFullYear();  // Full year (e.g., 2024)
      const hours = String(currentDate.getHours()).padStart(2, '0');  // Hours with leading zero
      const minutes = String(currentDate.getMinutes()).padStart(2, '0');  // Minutes with leading zero
      const seconds = String(currentDate.getSeconds()).padStart(2, '0');  // Seconds with leading zero

      // Combine them into the desired format
      const formattedDate = `${month} ${day} ${hours}:${minutes}:${seconds}`;

      setDate(formattedDate);

      const emaLow = calculateEMA(response?.historicalResponseEx?.Result)


      // console.log("emaLow",emaLow    ,response?.historicalResponseEx?.Result[0].Close )
      if (response?.historicalResponseEx?.Result[0].Close > emaLow) {

        onTradingChangetwo('Bullish');
        // console.log(emaLow,"Bullish: Close is greater than EMA",response?.historicalResponseEx?.Result[0]?.close);
      } else {
        // console.log("Bearish: Close is less than EMA");
        onTradingChangetwo('Bearish');
      }
      // console.log(">>REs>>>", response)
      // console.log("response?.formattedData", response.formattedData)
      if (Array.isArray(response?.formattedData)) {
        let middleValues = response?.formattedData
        let midleIndex;
        response.formattedData.some((item, index) => {
          if (item?.strikePrice >= response?.spotPrice?.LastTradePrice) {
            midleIndex = index;
            return true;  // This will stop the iteration
          }
          return false;
        });

        // response.formattedData.forEach((item, index) => {
        //   if (item.strikePrice >= response.spotPrice?.LastTradePrice) {
        //     midleIndex = index;
        //     return;  // This will stop the iteration
        //   }
        // });

        let upperIndex;
        let lowerIndex;

        if (localStorage.getItem("stock") === "GOLD" || localStorage.getItem("stock") === "SILVER" || localStorage.getItem('stock') === 'CRUDEOIL' || localStorage.getItem("stock") === "COPPER" || localStorage.getItem("stock") === "NATURALGAS") {

          upperIndex = Math.max(midleIndex - 40, 0);  // Prevent negative indices
          lowerIndex = Math.min(midleIndex + 40, middleValues.length);
        } else {
          upperIndex = Math.max(midleIndex - 20, 0);  // Prevent negative indices
          lowerIndex = Math.min(midleIndex + 20, middleValues.length);
        }
        const finalData = middleValues.slice(upperIndex, lowerIndex)
        // console.log("finalData1", finalData)

        if (localStorage.getItem("stock") === "GOLD" || localStorage.getItem("stock") === "SILVER") {

          let step;
          let currentValue
          // localStorage.getItem("stock") === "GOLD" ? currentValue = 85000 : currentValue = 80000 
          localStorage.getItem("stock") === "GOLD" ? step = 500 : step = 1000
          // Convert strike prices to numbers and sort
          const strikePrices = finalData.map(item => parseInt(item.strikePrice)).sort((a, b) => a - b);

          // Find the first strike price that ends with '000'
          currentValue = strikePrices.find(price => price % 1000 === 0);
          // console.log("finalData2", finalData)
          // console.log("Final Data Before Filtering:", finalData.map(item => item.strikePrice));
          // console.log("Current Value Before Filtering:", currentValue);
          // console.log("Dynamic Current Value (Lowest Strike):", currentValue);

          const filteredArray = finalData.filter(value => {
            if (value.strikePrice == currentValue) {
              currentValue += step; // increment the current value
              return true;
            }
            return false;
          });
          // console.log("filteredArray", filteredArray)
          setData(filteredArray);
          // console.log(">>data1", data)
        } else {
          if (localStorage.getItem('reverseTable') === "true") {
            finalData.reverse();
          }
          setData(finalData);

          // console.log(">>data2", data)
        }



        // Find the highest and second-highest values for each column
        const ceOpenInterestChanges = [
          ...new Set(
            finalData.map(
              (item) => item.CE?.OpenInterestChange ?? 0
            )
          ),
        ].sort((a, b) => b - a);

        const ceOpenInterests = [
          ...new Set(
            finalData.map((item) => item.CE?.OpenInterest ?? 0)
          ),
        ].sort((a, b) => b - a);
        const ceTotalQtyTraded = [
          ...new Set(
            finalData.map((item) => item.CE?.TotalQtyTraded ?? 0)
          ),
        ].sort((a, b) => b - a);
        const peOpenInterestChanges = [
          ...new Set(
            finalData.map(
              (item) => item.PE?.OpenInterestChange ?? 0
            )
          ),
        ].sort((a, b) => b - a);
        const peOpenInterests = [
          ...new Set(
            finalData.map((item) => item.PE?.OpenInterest ?? 0)
          ),
        ].sort((a, b) => b - a);
        const peTotalQtyTraded = [
          ...new Set(
            finalData.map((item) => item.PE?.TotalQtyTraded ?? 0)
          ),
        ].sort((a, b) => b - a);

        const setValues = (values, setHighest, setSecond, setThird) => {
          setHighest(values[0] || 0);
          setSecond(values[1] || 0);
          setThird(values[2] || 0);
        };

        setValues(
          ceOpenInterestChanges,
          setHighestCEOIChange,
          setSecondHighestCEOIChange,
          setThirdHighestCEOIChange
        );
        setValues(
          ceOpenInterests,
          setHighestCEOI,
          setSecondHighestCEOI,
          setThirdHighestCEOI
        );
        setValues(
          ceTotalQtyTraded,
          setHighestCEVolume,
          setSecondHighestCEVolume,
          setThirdHighestCEVolume
        );
        setValues(
          peOpenInterestChanges,
          setHighestPEOIChange,
          setSecondHighestPEOIChange,
          setThirdHighestPEOIChange
        );
        setValues(
          peOpenInterests,
          setHighestPEOI,
          setSecondHighestPEOI,
          setThirdHighestPEOI
        );
        setValues(
          peTotalQtyTraded,
          setHighestPEVolume,
          setSecondHighestPEVolume,
          setThirdHighestPEVolume
        );

        const maxCEOI = Math.max(
          ...response.formattedData.map((item) => item.CE?.OpenInterest || 0)
        );
        const maxPEOI = Math.max(
          ...response.formattedData.map((item) => item.PE?.OpenInterest || 0)
        );
        const resistance = response.formattedData.find(
          (item) => item.CE?.OpenInterest === maxCEOI
        )?.strikePrice;
        const support = response.formattedData.find(
          (item) => item.PE?.OpenInterest === maxPEOI
        )?.strikePrice;
        setResistanceLevel(resistance);
        setSupportLevel(support);
      } else {
        // If formattedData is not an array, set loading to false
        setLoading(false);
        // console.error("Invalid formattedData:", response.formattedData);
      }

      setLoading(false);
    } catch (error) {
      // console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    let intervalId;
    setLoading(true);
    if (localStorage.getItem("stock") === "GOLD" || localStorage.getItem("stock") === "SILVER") {
      intervalId = setInterval(fetchData, 15000);
    } else {
      intervalId = setInterval(fetchData, 5000);
    }

    return () => clearInterval(intervalId);
  }, [searchValue]);

  //   const handleTimeChange = (time) => {
  //     setSelectedTime(time);
  // };


  const onHistoricsClick = (data) => {
    //  console.log('hostory click', data);
    PageServices.getHistorydata({
      instrumentIdentifier: data.InstrumentIdentifier,
      date: "28-may-2025",
      symbolToken: localStorage.getItem("stock"),
    }).then((response) => {
      // console.log("response123",response);

      const processData = (data) => {
        return data?.map((entry) => ({
          ...entry,
          LastTradeTime: new Date(
            entry.LastTradeTime * 1000
          ).toLocaleTimeString(),
        }));
      };

      const dataSet = processData(response.data);

      setProcessedData(dataSet);
    });
  };

  const fetchGreekChainData = (instrument) => {
    PageServices.getOptionGreekChain({
      instrument,
    })
      .then((response) => {
        const processData = response.map((entry) => ({
          time: new Date(entry.LastTradeTime * 1000).toLocaleTimeString(),
          OI: entry.OpenInterest,
          OIChange: entry.OIChange,
          Volume: entry.Volume,
        }));
        setGreekChainData(processData);
      })
      .catch((error) => console.log(error));
  };
useEffect(() => {
  if (!data || !data.InstrumentIdentifier) return;

  const fetchHistoricData = async () => {
    try {
      const response = await PageServices.getHistorydataOichg({
        instrumentIdentifier: data.InstrumentIdentifier,
        date: "28-may-2025",
        symbolToken: localStorage.getItem("stock"),
      });
console.log(">>>>responsehi",response)
      const ceData = response.data.ce;
      const peData = response.data.pe;

      const formattedData = ceData.map((ceItem, index) => {
        const peItem = peData[index];
        return {
          time: new Date(ceItem.LastTradeTime * 1000).toLocaleTimeString(),
          ceOI: ceItem.OpenInterest,
          peOI: peItem.OpenInterest,
          oiDifference: peItem.OpenInterest - ceItem.OpenInterest,
          ceOIChange: ceItem.OpenInterestChange,
          peOIChange: peItem.OpenInterestChange,
          oiChgDifference: peItem.OpenInterestChange - ceItem.OpenInterestChange,
          ceVolume: ceItem.TotalQtyTraded,
          peVolume: peItem.TotalQtyTraded,
          volumeDifference: peItem.TotalQtyTraded - ceItem.TotalQtyTraded,
          volumedevide: ceItem.TotalQtyTraded / peItem.TotalQtyTraded,
          ceLtp: ceItem.LastTradePrice,
          peLtp: peItem.LastTradePrice,
          pcrOi:
            ceItem.OpenInterest !== 0
              ? peItem.OpenInterest / ceItem.OpenInterest
              : 0,
          pcrOiChange:
            ceItem.OpenInterestChange !== 0
              ? peItem.OpenInterestChange / ceItem.OpenInterestChange
              : 0,
        };
      });

      setChartData(formattedData);
    } catch (error) {
      console.log("Error fetching history data:", error);
    }
  };

  fetchHistoricData();
}, [data]); // ✅ data added here as dependency


  const formatTime = (timeString) => {
    const [hours, minutes, seconds] = timeString.split(":");
    const suffix = hours >= 12 ? "PM" : "AM";
    const adjustedHours = hours % 12 || 12;
    return `${adjustedHours}:${minutes} ${suffix}`;
  };

  // Function to process data fetched from the API
  const processGreekChainData = (data) => {
    return data.map((entry) => ({
      time: formatTime(entry.time),
      OI: entry.OI,
      OIChange: entry.OIChange,
      Volume: entry.Volume,
    }));
  };

  const OptionChainChart = ({ data }) => (
    <LineChart
      width={950}
      height={500}
      data={processGreekChainData(data)}
      margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="time" />
      <YAxis />
      <Tooltip />
      <Legend />
      <Line type="monotone" dataKey="OI" stroke="#0000FF" />
      <Line type="monotone" dataKey="OIChange" stroke="#00FF00" />
      <Line type="monotone" dataKey="Volume" stroke="#FF0000" />
    </LineChart>
  );

  // Modal trigger
  const onModalOpen = (instrument) => {
    fetchGreekChainData(instrument); // Fetch data when the modal opens
  };

  const getSpotPriceRow = () => {
    if (spotPrice) {


      return (
        <tr key="spot-price">
          <td  className="strike-pric spot-price">
            <button
              style={{
                background: "#004894",
                color: "#fff",
                borderRadius: "35px",
                padding: "8px 30px",
              }}
            >
              {/* {localStorage.getItem('showFuturePrice')==='true' || null ? `F : ${futurePrice}` : ' '} * Spot : {spotPrice} * F-S : {(futurePrice - spotPrice).toFixed(1)} */}
              F : {futurePrice} * Spot : {spotPrice} * F-S : {(futurePrice - spotPrice).toFixed(1)}
            </button>
          </td>
        </tr>
      );
    }
  };

  // const getNearestValues = () => {
  //   const nearestIndex = data.findIndex(
  //     (item) => item.strikePrice >= spotPrice
  //   );
  //   const start = Math.max(0, nearestIndex - 2); // 2 values before the nearest
  //   const end = Math.min(data.length, nearestIndex + 3); // 2 values after the nearest
  //   return data.slice(start, end);
  // };

  const formatNumber = (value) => {
  const useValue = Number(value); // Convert to number safely

  if (isNaN(useValue)) {
    return "0"; // or return value, or "-"
  }

  return useValue.toLocaleString('en-IN');
};


  const calculatePercentage = (value, highestValue) => {
    if (highestValue === 0) return 0;
    return ((value / highestValue) * 100).toFixed(2);
  };

  // const handleButtonClick = () => {
  //   setShowClock(true); // Show clock when the button is clicked
  // };



  const ivCalculate = (value) => {
    const iv = (spotPrice - value?.strikePrice)
    const tv = value?.CE?.LastTradePrice - iv
    return tv.toFixed(2);
  }
  const ivCalculatePE = (value) => {
    const iv = (value?.strikePrice - spotPrice)
    const tv = value?.CE?.LastTradePrice - iv
    return tv.toFixed(2);
  }


  const countCprVolume = (value) => {
    let totalCeOI = 0;
    let totalPeOI = 0;

    let obj = {};
    // let middleValues = value.slice(
    //   Math.max(0, Math.floor(value.length / 2) - 7),
    //   Math.min(value.length, Math.floor(value.length / 2) + 8)
    // );
    let middleValues = value


    // Iterate over the middleValues to sum the quantities
    middleValues?.forEach((item) => {
      totalCeOI += item?.CE?.TotalQtyTraded || 0;  // Add to totalCeOI, use 0 if undefined
      totalPeOI += item?.PE?.TotalQtyTraded || 0;  // Add to totalPeOI, use 0 if undefined
    });

    // Calculate PCR OI (Put/Call Ratio)
    const pcrOi = totalCeOI === 0 ? 0 : totalCeOI / totalPeOI;

    obj.totalCeOI = totalCeOI.toFixed(2);  // Fixed to 2 decimal places
    obj.totalPeOI = totalPeOI.toFixed(2);  // Fixed to 2 decimal places
    obj.pcrOi = pcrOi.toFixed(2);  // Fixed to 2 decimal places

    return obj;
  };


  const countPcrOIchg = (value) => {
    let totalCeOI = 0; // Initialize to 0 for accumulation
    let totalPeOI = 0; // Initialize to 0 for accumulation

    let obj = {};

    // Extract a portion of the array to work with
    // let middleValues = value.slice(
    //   Math.max(0, Math.floor(value.length / 2) - 7),
    //   Math.min(value.length, Math.floor(value.length / 2) + 8)
    // );

    let middleValues = value

    // Accumulate OpenInterestChange values for CE and PE
    middleValues?.forEach((item) => {
      totalCeOI += item?.CE?.OpenInterestChange || 0;  // Accumulate CE OpenInterestChange
      totalPeOI += item?.PE?.OpenInterestChange || 0;  // Accumulate PE OpenInterestChange
    });

    // Calculate the Put/Call Ratio (PCR) OI change (avoid division by 0)
    const pcrOi = totalCeOI === 0 ? 0 : totalPeOI / totalCeOI;

    // Format the result with two decimal places
    obj.totalCeOI = totalCeOI.toFixed(2);
    obj.totalPeOI = totalPeOI.toFixed(2);
    obj.pcrOi = pcrOi.toFixed(2);

    return obj;
  };


  const countPcrOI = (value) => {
    let totalCeOI = 0; // Initialize for accumulation
    let totalPeOI = 0; // Initialize for accumulation

    let obj = {};
    // let middleValues = value.slice(
    //   Math.max(0, Math.floor(value.length / 2) - 7),
    //   Math.min(value.length, Math.floor(value.length / 2) + 8)
    // );
    let middleValues = value

    // Accumulate OpenInterest for both CE and PE
    middleValues?.forEach((item) => {
      totalCeOI += item?.CE?.OpenInterest || 0;  // Add OpenInterest from CE
      totalPeOI += item?.PE?.OpenInterest || 0;  // Add OpenInterest from PE
    });

    // Calculate PCR OI (Put/Call Ratio)
    const pcrOi = totalCeOI === 0 ? 0 : totalPeOI / totalCeOI;

    // Format the result to two decimal places
    obj.totalCeOI = totalCeOI.toFixed(2);
    obj.totalPeOI = totalPeOI.toFixed(2);
    obj.pcrOi = pcrOi.toFixed(2);

    return obj;
  };


  const countUperHeader = (value) => {
    let upper = [];
    let lower = [];

    let upperSum = 0;
    let lowerSum = 0;
    let upperSumPE = 0;
    let lowerSumPE = 0;
    let ltpChg = 0;
    let ltpChgPE = 0;
    let oiChg = 0;
    let oiChgPE = 0;
    let itmTv = 0;
    let itmTvPE = 0;

    value?.forEach((item) => {
      ltpChg += item?.CE?.PriceChange;
      ltpChgPE += item?.PE?.PriceChange
      oiChg += item?.CE?.OpenInterestChange;
      oiChgPE += item?.PE?.OpenInterestChange
      if (item.strikePrice < spotPrice) {
        upperSum += item.CE.LastTradePrice;
        upperSumPE += item.PE.LastTradePrice;
        upper.push(item);
      } else {
        lowerSum += item.CE.LastTradePrice;
        lowerSumPE += item.PE.LastTradePrice;
        lower.push(item);
      }
    });


    if (upperSum > lowerSum) {
      // ITM
      upper.forEach((item) => {
        const iv = (spotPrice - item?.strikePrice);
        const tv = item?.CE?.LastTradePrice - iv;
        itmTv += tv;
      });
    } else {
      // OTM
      lower.forEach((item) => {
        const iv = (spotPrice - item?.strikePrice);
        const tv = item?.CE?.LastTradePrice - iv;
        itmTv += tv;

      });
    }

    if (upperSumPE > lowerSumPE) {
      // ITM
      upper.forEach((item) => {
        const iv = (item?.strikePrice - spotPrice);
        const tv = item?.CE?.LastTradePrice - iv;
        itmTvPE += tv;
      });
    } else {
      // OTM
      lower.forEach((item) => {
        const iv = (item?.strikePrice - spotPrice);
        const tv = item?.CE?.LastTradePrice - iv;
        itmTvPE += tv;
      });
    }

    const oichagPePer = (oiChgPE * 100 / (oiChgPE + oiChg))
    const oichagPer = (oiChg * 100 / (oiChg + oiChgPE))

    const obj = {
      itmTv: itmTv.toFixed(2),
      itmTvPE: itmTvPE.toFixed(2),
      ltpChg: ltpChg.toFixed(2),
      ltpChgPE: ltpChgPE.toFixed(2),
      oichagPer: oichagPer.toFixed(2),
      oichagPePer: oichagPePer.toFixed(2)
    };

    return obj;
  };

  // Standard Normal CDF (N(x))
  function erf(x) {
    const a1 = 0.254829592;
    const a2 = -0.284496736;
    const a3 = 1.421413741;
    const a4 = -1.453152027;
    const a5 = 1.061405429;
    const p = 0.3275911;

    const sign = (x >= 0) ? 1 : -1;
    x = Math.abs(x);

    const t = 1.0 / (1.0 + p * x);
    const y = 1.0 - (((((a5 * t + a4) * t + a3) * t + a2) * t + a1) * t) * Math.exp(-x * x);

    return sign * y;
  }

  // Standard Normal CDF (N(x))
  function normCDF(x) {
    return (1.0 + erf(x / Math.sqrt(2))) / 2.0;
  }

  // Standard Normal PDF (N'(x))
  function normPDF(x) {
    return Math.exp(-0.5 * x * x) / Math.sqrt(2 * Math.PI);
  }

  // Black-Scholes Call Option Price
  function blackScholesCall(S, K, T, r, sigma) {
    if (S <= 0 || K <= 0 || T <= 0 || sigma <= 0) {
      return NaN;  // Invalid input, return NaN
    }

    const d1 = (Math.log(S / K) + (r + 0.5 * sigma * sigma) * T) / (sigma * Math.sqrt(T));
    const d2 = d1 - sigma * Math.sqrt(T);
    const callPrice = S * normCDF(d1) - K * Math.exp(-r * T) * normCDF(d2);
    return callPrice;
  }

  // Gamma (Γ) Calculation
  function calculateGamma(S, K, T, r, sigma) {
    if (S <= 0 || K <= 0 || T <= 0 || sigma <= 0) {
      return NaN;  // Invalid input, return NaN
    }

    const d1 = (Math.log(S / K) + (r + 0.5 * sigma * sigma) * T) / (sigma * Math.sqrt(T));
    const gamma = normPDF(d1) / (S * sigma * Math.sqrt(T));
    return gamma;
  }

  // Calculate Implied Volatility using Newton-Raphson method
  function impliedVolatility(S, K, T, r, marketPrice) {
    if (S <= 0 || K <= 0 || T <= 0 || marketPrice <= 0) {
      return NaN;  // Invalid input, return NaN
    }

    const tolerance = 1e-5;
    let sigma = 0.2; // Initial guess for IV
    let maxIter = 100;
    let iter = 0;

    while (iter < maxIter) {
      const price = blackScholesCall(S, K, T, r, sigma);
      if (isNaN(price)) {
        return NaN; // If price calculation fails, return NaN
      }

      const vega = calculateGamma(S, K, T, r, sigma) * S * Math.sqrt(T); // Vega is related to Gamma
      if (vega === 0) {
        return NaN; // Vega cannot be zero, return NaN
      }

      const diff = price - marketPrice;
      if (Math.abs(diff) < tolerance) break;
      sigma = sigma - diff / vega; // Newton-Raphson step

      iter++;
    }

    if (iter >= maxIter) {
      return NaN;  // If no convergence after max iterations, return NaN
    }

    return sigma; // Returns the implied volatility
  }


  const onStrikePriceClick = (item, index) => {
    setSelectedStrikePrice(item.strikePrice);

    const d = item?.PE?.LastTradePrice - data[index + 1]?.CE?.LastTradePrice;

    const m = item?.CE?.LastTradePrice - data[index - 1]?.PE?.LastTradePrice;
    console.log("d,m", d, m);
    const gamma = item?.CE?.Gamma || 1;
    const mP = (gamma * m) / 100;
    const dP = (gamma * d) / 100;
    console.log("item", item);
    console.log("item?.CE?.Gamma", item?.CE?.Gamma);
    console.log("Gamma", gamma);
    console.log("dp,mp", dP, mP);
    console.log("mp", mP, "................m", m, "................d", d, "................dP", dP, ".............d + dP", d + dP, "...............m + m p", m + mP, "................spotPrice", spotPrice)
    setResistance((d + dP) + spotPrice);

    setSupport(spotPrice - (m + mP));
    console.log("resistance", resistance);
    console.log("support", support);

    console.log("firstOptionChain?.data?", firstOptionChain?.data)
    const item2 = firstOptionChain?.data?.find((optionItem) => optionItem.strikePrice === item.strikePrice);


    const d2 = item2?.PE?.LastTradePrice - data[index + 1]?.CE?.LastTradePrice;
    const m2 = item2?.CE?.LastTradePrice - data[index - 1]?.PE?.LastTradePrice;

    setResistance2(d2 + firstOptionChain?.spot?.LastTradePrice);
    setSupport2(firstOptionChain?.spot?.LastTradePrice - m2);

    // future resistance and support
    const dF = item?.PE?.LastTradePrice - data[index + 1]?.CE?.LastTradePrice;

    const mF = item?.CE?.LastTradePrice - data[index - 1]?.PE?.LastTradePrice;

    const mPF = (item?.CE?.Gamma * mF) / 100;
    const dPF = (item?.CE?.Gamma * dF) / 100;

    setFutureResistance((dF + dPF) + futurePrice);

    setFutureSupport(futurePrice - (mF + mPF));

    const d2F = item2?.PE?.LastTradePrice - data[index + 1]?.CE?.LastTradePrice;

    const m2F = item2?.CE?.LastTradePrice - data[index - 1]?.PE?.LastTradePrice;
    // setFutureResistance2(d2F + firstOptionChain?.future?.LastTradePrice) ;
    setFutureResistance2(d2F + futurePrice);
    // setFutureSupport2(firstOptionChain?.future?.LastTradePrice - m2F);
    setFutureSupport2(futurePrice - m2F);

    // console.log("item2", item2);
    // console.log(d2);
    // console.log(m2);
  }
  // console.log("resistance2", resistance2)
  // console.log("support2", support2)
  // const onFutureStrikePriceClick = (item,index) => {

  //   setSelectedStrikePrice(item.strikePrice);

  //   const df = item?.PE?.LastTradePrice - data[index+1]?.CE?.LastTradePrice;

  //   const mf = item?.CE?.LastTradePrice - data[index-1]?.PE?.LastTradePrice;

  //   const mPF = (item?.CE?.Gamma * mf )/100;
  //   const dPF = (item?.CE?.Gamma * df )/100;

  //   setFutureResistance((dF +dPF) + futurePrice) ;

  //   setFutureSupport(futurePrice - (mF + mPF));

  //   const d2F = item2?.PE?.LastTradePrice - data[index+1]?.CE?.LastTradePrice;

  //   const m2F = item2?.CE?.LastTradePrice - data[index-1]?.PE?.LastTradePrice;

  //   setFutureResistance2(d2F + firstOptionChain?.future?.LastTradePrice) ;

  //   setFutureSupport2(firstOptionChain?.future?.LastTradePrice - m2F);

  // }

  const countResistans = (item, index) => {
    const d = item?.PE?.LastTradePrice - data[index + 1]?.CE?.LastTradePrice;

    const m = item?.CE?.LastTradePrice - data[index - 1]?.PE?.LastTradePrice;

    const resistance = d + spotPrice;
    const support = spotPrice - m;

    return {
      resistance,
      support
    }
  }

  const countResistansAndSupport = (item, index) => {
    if (item?.CE?.OpenInterestChange >= item?.PE?.OpenInterestChange && item?.CE?.OpenInterestChange >= 2 * item?.PE?.OpenInterestChange && item?.CE?.OpenInterestChange > 0) {
      return <span style={{ color: '#fff', fontWeight: 'bold' }}>Strong R &nbsp;</span>
    } else if (item?.CE?.OpenInterestChange >= item?.PE?.OpenInterestChange && item?.CE?.OpenInterestChange < 2 * item?.PE?.OpenInterestChange) {
      return <span style={{ color: '#fff', fontWeight: 'bold' }}>Normal R &nbsp;</span>
    } else if (item?.PE?.OpenInterestChange >= item?.CE?.OpenInterestChange && item?.PE?.OpenInterestChange >= 2 * item?.CE?.OpenInterestChange && item?.CE?.OpenInterestChange > 0) {
      return <span style={{ color: '#fff', fontWeight: 'bold' }}>Strong S &nbsp;</span>
    } else if (item?.PE?.OpenInterestChange >= item?.CE?.OpenInterestChange && item?.PE?.OpenInterestChange < 2 * item?.CE?.OpenInterestChange) {
      return <span style={{ color: '#fff', fontWeight: 'bold' }}> Normal S &nbsp;</span>
    }
    else {
      return ''
    }
  }

  const countSupportAndResistance = (item, index) => {
    if (item?.PE?.OpenInterestChange >= item?.CE?.OpenInterestChange && item?.PE?.OpenInterestChange >= 2 * item?.CE?.OpenInterestChange && item?.CE?.OpenInterestChange > 0) {
      return <span style={{ color: '#fff', fontWeight: 'bold' }}>Strong S &nbsp;</span>
    } else if (item?.PE?.OpenInterestChange >= item?.CE?.OpenInterestChange && item?.PE?.OpenInterestChange < 2 * item?.CE?.OpenInterestChange) {
      return <span style={{ color: '#fff', fontWeight: 'bold' }}>Noramal S &nbsp;</span>
    } else {
      return ''
    }
  }


  const getBackgroundClass = (item) => {
    const result = countResistansAndSupport(item);

    switch (result) {
      case 'Strong R':
        return 'bg-danger'; // red background
      case 'R':
        return 'bg-warning'; // yellow background
      case 'Strong S':
        return 'bg-success'; // green background
      case 'S':
        return 'bg-info'; // light blue background
      default:
        return ''; // no background color
    }
  };

  // const countPcrOiBStrike = (item) => {
  //   const result = item?.PE?.OpenInterest / item?.CE?.OpenInterest;
  //   return isFinite(result) ? (Math.round(result * 10) / 10) : 0;
  // };

  // const countPcrOiChgBStrike = (item) => {
  //   const result = item?.PE?.OpenInterestChange / item?.CE?.OpenInterestChange;
  //   return isFinite(result) ? (Math.round(result * 10) / 10) : 0;
  // };
  const countPcrOiBStrike = (item) => {
    const result = item?.PE?.OpenInterest / item?.CE?.OpenInterest;

    if (!isFinite(result)) return NaN;  // Agar result Infinite ho, toh NaN return karo
    if (isNaN(result)) return 0.0;      // Agar result NaN ho, toh 0.0 return karo

    return Math.round(result * 100) / 100; // Normal case ke liye rounded value return karo
  };

  const countPcrOiChgBStrike = (item) => {
    const result = item?.PE?.OpenInterestChange / item?.CE?.OpenInterestChange;

    if (!isFinite(result)) return 0.0;
    if (isNaN(result)) return NaN;

    return Math.round(result * 100) / 100;
  };


  const formatNumber2 = (value) => {
    let useValue;

    if (value >= 100000) {
      return `${(value / 100000).toFixed(2)}L`; // Format as lakhs
    } else if (value >= 1000) {
      return `${(value / 1000).toFixed(2)}k`; // Format as thousands
    } else {
      return value; // Return as is
    }


  };

  const intradayTrainding = () => {
    let midleIndex;

    data.some((item, index) => {
      if (item?.strikePrice >= spotPrice) {
        midleIndex = index;
        return true;  // This will stop the iteration
      }
      return false;
    });

    const firstStrike = data[midleIndex - 1];
    const secondStrike = data[midleIndex];
    const thirdStrike = data[midleIndex + 1];

    const totalCeOI = firstStrike?.CE?.OpenInterest + secondStrike?.CE?.OpenInterest + thirdStrike?.CE?.OpenInterest
    const totalPeOI = firstStrike?.PE?.OpenInterest + secondStrike?.PE?.OpenInterest + thirdStrike?.PE?.OpenInterest

    // return totalCeOI>totalPeOI ? 'BEARISH':'BULLISH'
    const result = totalCeOI > totalPeOI ? 'BEARISH' : 'BULLISH';
    const style = {
      color: totalCeOI > totalPeOI ? 'red' : 'green',
      fontSize: '25px',
      fontWeight: 'bold'
    };

    return <div style={style}>{result}</div>;

  }

  intradayTrainding();
  let isSpotPrice;

  


  // console.log("chart data",chartData)
  if (!isLoggedIn) {
    // Redirect to login if not logged in
    return <Navigate to="/" />;
  }
  // console.log("data1", data);
  // console.log("future", futurePrice);
  // console.log('showFuturePrice:', localStorage.getItem('showFuturePrice'));
// new code // Step 1: Unique, sorted strike prices
// Chart component
const MiniChart = ({ data = [] }) => {
  const staticData = [
    { CE: { OpenInterest: 1000, AverageTradedPrice: 50, LastTradePrice: 48 } },
    { CE: { OpenInterest: 1100, AverageTradedPrice: 52, LastTradePrice: 49 } },
    { CE: { OpenInterest: 1050, AverageTradedPrice: 51, LastTradePrice: 47 } },
    { CE: { OpenInterest: 1150, AverageTradedPrice: 53, LastTradePrice: 50 } },
    { CE: { OpenInterest: 1075, AverageTradedPrice: 51.5, LastTradePrice: 48.5 } },
    { CE: { OpenInterest: 1200, AverageTradedPrice: 54, LastTradePrice: 51 } },
  ];

  const chartData = (data.length > 0 ? data : staticData).map((item, index) => ({
    name: `T${index + 1}`,
    openInterest: item?.CE?.OpenInterest ?? 0,
    avgPrice: item?.CE?.AverageTradedPrice ?? 0,
    lastPrice: item?.CE?.LastTradePrice ?? 0,
  }));

  return (
    <div style={{ width: 400, height: 220 }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={chartData}>
          <XAxis dataKey="name" hide />

          {/* All Y-Axes are hidden */}
          <YAxis yAxisId="left" hide />
          <YAxis yAxisId="right" hide />
          <YAxis yAxisId="oi" hide />

          {/* Line 1 - Last Price (Black) */}
          <Line
            yAxisId="left"
            type="monotone"
            dataKey="lastPrice"
            stroke="#000"
            strokeWidth={2}
            dot={false}
            name="Last Price"
          />

          {/* Line 2 - VWAP / Avg Traded Price (Blue) */}
          <Line
            yAxisId="right"
            type="monotone"
            dataKey="avgPrice"
            stroke="blue"
            strokeWidth={2}
            dot={false}
            name="VWAP"
          />

          {/* Line 3 - Open Interest (Green) */}
          <Line
            yAxisId="oi"
            type="monotone"
            dataKey="openInterest"
            stroke="green"
            strokeWidth={2}
            dot={false}
            name="Open Interest"
          />

          <Tooltip
            contentStyle={{ fontSize: '12px' }}
            formatter={(value, name) => [value, name]}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};




 

  return (
    <div>
      <section className="lot-size-section">
        
        <div className="container-fluid px-0">
          <div className="lot-size-inner snapshot-table" >
            <table className="table-left">
              {loading ? (
                <div className="loading-indicator">
                  <img src="/img/Spinner-2.gif" alt="Loading..." />
                </div> // Display loading indicator when loading is true
              ) : (
                <tbody>
                   <tr className="table-first">
                   <th colSpan={5}>CALLS</th>
                                      
                    <th className="table-right" colSpan={5}>PUTS
                    </th>
                  </tr>
                  <tr>
                    <th>Chart</th>
                    <th>OI Chg</th>
                    <th>OI</th>
                    <th>VWAP</th>
                    <th>LTP</th>
                    {localStorage.getItem('showColoum') === 'true' && (
                      <th style={{ color: '#fff',backgroundColor:'blue' }}>Probable Swing High</th>
                    )}
                    <th className="strike-price">SP:PCR Oi/OiC</th>
                    {localStorage.getItem('showColoum') === 'true' && (
                      <th style={{ color: '#fff',backgroundColor:'blue' }} className="table-right">Probable Swing Low</th>
                    )}
                    <th className="table-right">LTP</th>
                    <th className="table-right">VWAP</th>
                    <th className="table-right">OI</th>
                    <th className="table-right">OI Chg</th>
                       <th className="table-right">Chart</th>

                  </tr>

                  {Array.isArray(data) &&
                    data.map((item, index) => {
                      localStorage.getItem('reverseTable') === 'true' ? isSpotPrice =
                        spotPrice &&
                        item.strikePrice <= spotPrice &&
                        (!data[index - 1] ||
                          spotPrice < data[index - 1].strikePrice) : isSpotPrice =
                      spotPrice &&
                      item.strikePrice >= spotPrice &&
                      (!data[index - 1] ||
                        spotPrice > data[index - 1].strikePrice);
                      return (
                        <React.Fragment key={index}
                        >
                          {isSpotPrice && getSpotPriceRow()}
                          <tr
                            // style={{
                            //   backgroundColor: isSpotPrice
                            //     ? "#d1e7dd"
                            //     : "transparent",
                            // }}
                            style={{
                              ...(isSpotPrice && { backgroundColor: "#d1e7dd" })
                            }}

                          >
                          <td> <div style={{ width: 300, height: 100 }}>
                              <MiniChart />
                            </div></td>
                            <td>
                              <button
                                
                              >
                                <div>
                                  { formatNumber(item.CE?.OpenInterestChange ?? 0)
                                    }
                                </div>
                              </button>
                            </td>
                            <td>
                              <button
                                
                              >
                               
                                <div>
                                  { formatNumber(item.CE?.OpenInterest ?? 0)
                                    }
                                </div>
                              </button>
                            </td>
                            <td>
                              <button
                                
                              >
                               
                                <div>
                                 {item.CE?.AverageTradedPrice ?? 0}
                                </div>
                              </button>
                            </td>
                            <td>
                              <button
                               
                              >
                                {item.CE?.LastTradePrice ?? 0}
                              </button>
                            </td>
                            {localStorage.getItem('showColoum') === 'true' && (
                              <td style={{ color: '#fff',backgroundColor:'blue' }} >
                                <button
                                  data-bs-toggle="modal"
                                  data-bs-target="#LPTcalculatorModel"
                                  style={{
                                    backgroundColor: 'blue',
                                    color: '#fff',
                                    border: 'none',
                                    padding: '5px 10px',
                                    cursor: 'pointer',
                                  }}
                                >
                                  {countResistansAndSupport(item, index)}
                                  {countResistans(item, index).resistance.toFixed(2)}
                                </button>
                              </td>
                            )}

                            <td className={`strike-price ${getBackgroundClass(item)}`}>
                              <button
                                
                              >
                                {item.strikePrice}
                              </button>
                            </td>
                            {localStorage.getItem('showColoum') === 'true' && (
                              <td className="table-right" style={{
                               backgroundColor: "blue",color:'#fff' ,
                              }}>
                                <button
                                  data-bs-toggle="modal"
                                  data-bs-target="#CombinedpriceModel"
                                  style={{
                                    backgroundColor: 'blue',
                                    color: '#fff',
                                    border: 'none',
                                    padding: '5px 10px',
                                    cursor: 'pointer',
                                  }}
                                >
                                  {countSupportAndResistance(item, index)}
                                  {countResistans(item, index).support.toFixed(2)}
                                </button>
                              </td>
                            )}
                            <td className="table-right" 
                            >
                              <button
                              >
                                {item.PE?.LastTradePrice ?? 0} 
                              </button>
                            </td>
                            <td className="table-right" >
                              <button
                                
                              >
                                
                                <div>
                                 {item.PE?.AverageTradedPrice ?? 0}
                                </div>
                              </button>
                            </td>
                            <td className="table-right" >
                              <button
                              
                              >
                               
                                <div>
                                  {formatNumber(item.PE?.OpenInterest ?? 0 )}

                                </div>
                              </button>
                            </td>
                            <td className="table-right" >
                              <button
                                
                              >
                               
                                <div>
                                  {
                                   formatNumber(item.PE?.OpenInterestChange ?? 0)
                                  }
                                  
                                </div>
                              </button>
                            </td>
                            <td> <div style={{ width: 300, height: 100 }}>
                              <MiniChart />
                            </div></td>
                            
                          </tr>
                        </React.Fragment>
                      );
                    })}
                </tbody>
              )}
            </table>
          </div>
        </div>
      </section>
      <section className="volume-section ">
        <div className="container">
          <div className="volume-section-inner">
            {/* <ul className="list-unstyled d-flex align-items-center justify-content-center">
              <li>
                <a href="#">TV PE: 50%</a>
              </li>
              <li>
                {" "}
                <h3>
                  Delta PE: 3.70 <br />
                  LTP PE: 31%
                </h3>
              </li>
              <li>
                {" "}
                <h3>
                  Delta PE: 3.70 <br />
                  LTP PE: 31%
                </h3>
              </li>
              <li>
                <a href="#" className="text-danger">
                  TV PE: 50%
                </a>
              </li>
            </ul> */}
          </div>
         
        </div>
      </section>
      

      {/* ======== Setting popup ======== */}
      <div
        className="modal fade"
        id="settingModel"
        tabIndex={-1}
        aria-labelledby="settingModelLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content modal-bg-light-blue">
            <div className="modal-header">
              <h5 className="modal-title" id="settingModelLabel">
                Setting
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="setting-functionalty-outer popup-list">
                <ul className="list-unstyled">
                  <li>
                    <div className="popup-list-title">
                      <span>
                        <img src="img/light-mode.svg" alt="icon" />
                      </span>
                      <span>Light Mode</span>
                    </div>
                    <div className="toggle-status">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input light-mode"
                          type="checkbox"
                          id="flexSwitchCheckChecked"
                          defaultChecked
                        />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="popup-list-title">
                      <span>
                        <img src="img/highlight.svg" alt="icon" />
                      </span>
                      <span>ITM &amp; OTM Highlight</span>
                    </div>
                    <div className="toggle-status">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input itm-otm-highlight"
                          type="checkbox"
                          id="flexSwitchCheckChecked"
                          defaultChecked
                        />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="popup-list-title">
                      <span>
                        <img src="img/screen-desktop.svg" alt="icon" />
                      </span>
                      <span>Keep Screen Awake</span>
                    </div>
                    <div className="toggle-status">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input keep-screen-awake"
                          type="checkbox"
                          id="flexSwitchCheckChecked"
                          defaultChecked
                        />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="popup-list-title">
                      <span>
                        <img src="img/price-tag.svg" alt="icon" />
                      </span>
                      <span>Show Future Price</span>
                    </div>
                    <div className="toggle-status">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input show-future-price"
                          type="checkbox"
                          id="flexSwitchCheckChecked"
                          defaultChecked
                        />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="popup-list-title">
                      <span>
                        <img src="img/top-so.svg" alt="icon" />
                      </span>
                      <span>High Third Highest</span>
                    </div>
                    <div className="toggle-status">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input high-third-highest"
                          type="checkbox"
                          id="flexSwitchCheckChecked"
                          defaultChecked
                        />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="popup-list-title">
                      <span>
                        <img src="img/number-sign.svg" alt="icon" />
                      </span>
                      <span>Show Numbers</span>
                    </div>
                    <div className="toggle-status">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input show-numbers"
                          type="checkbox"
                          id="flexSwitchCheckChecked"
                          defaultChecked
                        />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="popup-list-title">
                      <span>
                        <img src="img/table-column.svg" alt="icon" />
                      </span>
                      <span>Reverse Table</span>
                    </div>
                    <div className="toggle-status">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input reverse-table"
                          type="checkbox"
                          id="flexSwitchCheckChecked"
                          defaultChecked
                        />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="popup-list-title">
                      <span>
                        <img src="img/percentage.svg" alt="icon" />
                      </span>
                      <span>Prefer Percentage</span>
                    </div>
                    <div className="toggle-status">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input prefer-percentage"
                          type="checkbox"
                          id="flexSwitchCheckChecked"
                          defaultChecked
                        />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="popup-list-title">
                      <span>
                        <img src="img/show-qt.svg" alt="icon" />
                      </span>
                      <span>Show QT in Lots</span>
                    </div>
                    <div className="toggle-status">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input show-qt"
                          type="checkbox"
                          id="flexSwitchCheckChecked"
                          defaultChecked
                        />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="popup-list-title">
                      <span>
                        <img src="img/trash.svg" alt="icon" />
                      </span>
                      <span>Clear Data Cache</span>
                    </div>
                    <div className="toggle-status">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input clear-data-cache"
                          type="checkbox"
                          id="flexSwitchCheckChecked"
                          defaultChecked
                        />
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ======== Search Nifty popup ======== */}
      <div
        className="modal fade"
        id="searchNiftyModel"
        tabIndex={-1}
        aria-labelledby="searchNiftyModelLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content modal-bg-light-green">
            <div className="modal-body py-4 px-4">
              <form className="search-field-container">
                <div className="form-input">
                  <input
                    type="search"
                    name="Search Nifty"
                    className="form-control"
                    placeholder="Search Stock/Index"
                  />
                </div>
              </form>
              <div className="nifty-index-list">
                <ul className="list-unstyled">
                  <li>
                    <button>Banknifty</button>
                  </li>
                  <li>
                    <button>Finnifty</button>
                  </li>
                  <li>
                    <button>Nifty_Mid_Select</button>
                  </li>
                  <li>
                    <button>Nifty</button>
                  </li>
                  <li>
                    <button>Naturalgas</button>
                  </li>
                  <li>
                    <button>Crudeoil</button>
                  </li>
                  <li>
                    <button>Usdinr</button>
                  </li>
                  <li>
                    <button>Sensex</button>
                  </li>
                  <li>
                    <button>bankex</button>
                  </li>
                  <li>
                    <button>Aartiind</button>
                  </li>
                  <li>
                    <button>Sensex</button>
                  </li>
                  <li>
                    <button>bankex</button>
                  </li>
                  <li>
                    <button>Aartiind</button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ======== OI Percentage Graph popup ======== */}
      <div
        className="modal fade "
        id="oichartModel"
        tabIndex={-1}
        aria-labelledby="oichartModelLabel"
        aria-hidden="true "
      >
        <div className="modal-dialog ai-chart modal-dialog-centered">
          <div className="modal-content modal-bg-light-blue">
            <div className="modal-header">
              <h5 className="modal-title" id="oichartModelLabel">
                OI Charts
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <ul
                className="nav nav-pills ai-chart-nav mb-3"
                id="pills-tab"
                role="tablist"
              >
                <li className="nav-item ai-chart-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="pills-oi-change-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-oi-change"
                    type="button"
                    role="tab"
                    aria-controls="pills-oi-change"
                    aria-selected="true"
                  >
                    OI Change
                  </button>
                </li>
                <li className="nav-item ai-chart-item" role="presentation">
                  <button
                    className="nav-link"
                    id="pills-oi-graph-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-oi-graph"
                    type="button"
                    role="tab"
                    aria-controls="pills-oi-graph"
                    aria-selected="false"
                  >
                    OI Graph
                  </button>
                </li>
                <li className="nav-item ai-chart-item" role="presentation">
                  <button
                    className="nav-link"
                    id="pills-volume-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-volume"
                    type="button"
                    role="tab"
                    aria-controls="pills-volume"
                    aria-selected="false"
                  >
                    Volume
                  </button>
                </li>
                <li className="nav-item ai-chart-item" role="presentation">
                  <button
                    className="nav-link"
                    id="pills-pcr-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-pcr"
                    type="button"
                    role="tab"
                    aria-controls="pills-pcr"
                    aria-selected="false"
                  >
                    PCR
                  </button>
                </li>
                <li className="nav-item ai-chart-item" role="presentation">
                  <button
                    className="nav-link"
                    id="pills-ce-build-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-ce-build"
                    type="button"
                    role="tab"
                    aria-controls="pills-ce-build"
                    aria-selected="false"
                  >
                    CE BuildUp
                  </button>
                </li>
                <li className="nav-item ai-chart-item" role="presentation">
                  <button
                    className="nav-link"
                    id="pills-pe-build-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-pe-build"
                    type="button"
                    role="tab"
                    aria-controls="pills-pe-build"
                    aria-selected="false"
                  >
                    PE BuildUp
                  </button>
                </li>
              </ul>

            </div>
            <div className="tab-content" id="pills-tabContent">

              <div
                className="tab-pane fade show active"
                id="pills-oi-change"
                role="tabpanel"
                aria-labelledby="pills-oi-change-tab"
              >
                <div className="ai-chart-img">
                  <div className="oi-chart-btn-inner">
                    <ul className="list-unstyled d-flex justify-content-center align-items-center">
                      <li>
                        {" "}
                        <button>
                          {" "}
                          <span />
                          OI Change PE-CE
                        </button>
                      </li>
                      <li>
                        {" "}
                        <button>
                          {" "}
                          <span className="oi-chart-green" />
                          OI Change PE
                        </button>
                      </li>
                      <li>
                        {" "}
                        <button>
                          {" "}
                          <span className="oi-chart-red" />
                          OI Change CE
                        </button>
                      </li>
                    </ul>
                  </div>
                  <LineChart
                    width={1300}
                    height={500}
                    data={chartData}
                    margin={{
                      top: 5,
                      right: 30,
                      left: 0,
                      bottom: 5,
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="time" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line
                      type="monotone"
                      dataKey="ceOIChange"
                      stroke="#F00000"
                      name="CE OIchg"
                      dot={false}
                    />
                    <Line
                      type="monotone"
                      dataKey="peOIChange"
                      stroke="#006E1C"
                      name="PE OIchg"
                      dot={false}
                    />
                    <Line
                      type="monotone"
                      dataKey="oiChgDifference"
                      stroke="#2196F3"
                      name="OIchg(PE - CE)"
                      dot={false}
                    />
                  </LineChart>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="pills-oi-graph"
                role="tabpanel"
                aria-labelledby="pills-oi-graph-tab"
              >
                <div className="ai-chart-img">
                  <div className="oi-chart-btn-inner">
                    <ul className="list-unstyled d-flex justify-content-center align-items-center">
                      <li>
                        {" "}
                        <button>
                          {" "}
                          <span />
                          OI (PE-CE)
                        </button>
                      </li>
                      <li>
                        {" "}
                        <button>
                          {" "}
                          <span className="oi-chart-green" />
                          PE OI
                        </button>
                      </li>
                      <li>
                        {" "}
                        <button>
                          {" "}
                          <span className="oi-chart-red" />
                          CE OI
                        </button>
                      </li>
                    </ul>
                  </div>
                  <LineChart
                    width={1300}
                    height={500}
                    data={chartData}
                    margin={{
                      top: 5,
                      right: 30,
                      left: 0,
                      bottom: 5,
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="time" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line
                      type="monotone"
                      dataKey="ceOI"
                      stroke="#F00000"
                      name="CE OI "
                      dot={false}
                    />
                    <Line
                      type="monotone"
                      dataKey="peOI"
                      stroke="#006E1C"
                      name="PE OI"
                      dot={false}
                    />
                    <Line
                      type="monotone"
                      dataKey="oiDifference"
                      stroke="#2196F3"
                      name="OI Difference (PE - CE)"
                      dot={false}
                    />
                  </LineChart>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="pills-volume"
                role="tabpanel"
                aria-labelledby="pills-volume-tab"
              >
                <div className="ai-chart-img">
                  <div className="oi-chart-btn-inner">
                    <ul className="list-unstyled d-flex justify-content-center align-items-center">
                      <li>
                        {" "}
                        <button>
                          {" "}
                          <span />
                          CE VOLUME
                        </button>
                      </li>
                      <li>
                        {" "}
                        <button>
                          {" "}
                          <span className="oi-chart-green" />
                          PE VOLUME
                        </button>
                      </li>
                      <li>
                        {" "}
                        <button>
                          {" "}
                          <span className="oi-chart-red" />
                          VOLUME (PE-CE)
                        </button>
                      </li>
                      <li>
                        {" "}
                        <button>
                          {" "}
                          <span className="oi-chart-red" />
                          VOLUME (PE/CE)
                        </button>
                      </li>
                      <li>
                        {" "}
                        <button>
                          {" "}
                          <span className="oi-chart-red" />
                          CE LTP
                        </button>
                      </li>
                      <li>
                        {" "}
                        <button>
                          {" "}
                          <span className="oi-chart-red" />
                          PE LTP
                        </button>
                      </li>
                    </ul>
                  </div>
                  <LineChart
                    width={1300}
                    height={500}
                    data={chartData}
                    margin={{
                      top: 5,
                      right: 30,
                      left: 0,
                      bottom: 5,
                    }}
                  >
                    <CartesianGrid strokeDasharray="4 4" />
                    <XAxis dataKey="time" />
                    <YAxis domain={['auto', 'auto']} />
                    <Tooltip />
                    <Legend />
                    <Line
                      type="monotone"
                      dataKey="ceVolume"
                      stroke="#8884d8"
                      name="CE VOLUME"
                      dot={false}
                    />
                    <Line
                      type="monotone"
                      dataKey="peVolume"
                      stroke="#82ca9d"
                      name="PE VOLUME"
                      dot={false}
                    />
                    <Line
                      type="monotone"
                      dataKey="volumeDifference"
                      stroke="#ff7300"
                      name="VOLUME(PE - CE)"
                      dot={false}
                    />
                    <Line
                      type="monotone"
                      dataKey="volumedevide"
                      stroke="#2eb043"
                      name="VOLUME(PE/CE)"
                      dot={false}
                    />
                    <Line
                      type="monotone"
                      dataKey="ceLtp"
                      stroke="#1593a1"
                      name="CE LTP"
                      dot={false}
                    />
                    <Line
                      type="monotone"
                      dataKey="peLtp"
                      stroke="#2515a1"
                      name="PE LTP"
                      dot={false}
                    />
                  </LineChart>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="pills-pcr"
                role="tabpanel"
                aria-labelledby="pills-pcr-tab"
              >
                <div className="ai-chart-img">
                  <div className="oi-chart-btn-inner">
                    <ul className="list-unstyled d-flex justify-content-center align-items-center">
                      <li>
                        {" "}
                        <button>
                          {" "}
                          <span />
                          PCR OI
                        </button>
                      </li>
                      <li>
                        {" "}
                        <button>
                          {" "}
                          <span className="oi-chart-green" />
                          PCR OI Change
                        </button>
                      </li>
                    </ul>
                  </div>
                  <LineChart
                    width={1300}
                    height={500}
                    data={chartData}
                    margin={{
                      top: 5,
                      right: 30,
                      left: 0,
                      bottom: 5,
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="time" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line
                      type="monotone"
                      dataKey="pcrOi"
                      stroke="#8884d8"
                      name="pcrOi"
                      dot={false}
                    />
                    <Line
                      type="monotone"
                      dataKey="pcrOiChange"
                      stroke="#82ca9d"
                      name="pcrOiChange"
                      dot={false}
                    />

                  </LineChart>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="pills-ce-build"
                role="tabpanel"
                aria-labelledby="pills-ce-build-tab"
              >
                <div className="ai-chart-img">
                  <div className="oi-chart-btn-inner">
                    <ul className="list-unstyled d-flex justify-content-center align-items-center">
                      <li>
                        {" "}
                        <button>
                          {" "}
                          <span />
                          CE OI
                        </button>
                      </li>
                      <li>
                        {" "}
                        <button>
                          {" "}
                          <span className="oi-chart-green" />
                          CE OI Change
                        </button>
                      </li>
                      <li>
                        {" "}
                        <button>
                          {" "}
                          <span className="oi-chart-red" />
                          CE LTP
                        </button>
                      </li>
                    </ul>
                  </div>
                  <LineChart
                    width={1300}
                    height={500}
                    data={chartData}
                    margin={{
                      top: 5,
                      right: 30,
                      left: 0,
                      bottom: 5,
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="time" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line
                      type="monotone"
                      dataKey="ceOI"
                      stroke="#2196F3"
                      name="CE OI"
                      dot={false}
                    />
                    <Line
                      type="monotone"
                      dataKey="ceOIChange"
                      stroke="#006E1C"
                      name="CE OIchg"
                      dot={false}
                    />
                    <Line
                      type="monotone"
                      dataKey="ceLtp"
                      stroke="#F00000"
                      name="CE LTP"
                      dot={false}
                    />
                  </LineChart>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="pills-pe-build"
                role="tabpanel"
                aria-labelledby="pills-pe-build-tab"
              >
                <div className="ai-chart-img">
                  <div className="oi-chart-btn-inner">
                    <ul className="list-unstyled d-flex justify-content-center align-items-center">
                      <li>
                        {" "}
                        <button>
                          {" "}
                          <span />
                          PE OI
                        </button>
                      </li>
                      <li>
                        {" "}
                        <button>
                          {" "}
                          <span className="oi-chart-green" />
                          PE OI CHANGE
                        </button>
                      </li>
                      <li>
                        {" "}
                        <button>
                          {" "}
                          <span className="oi-chart-red" />
                          PE LTP
                        </button>
                      </li>
                    </ul>
                  </div>
                  <LineChart
                    width={1300}
                    height={500}
                    data={chartData}
                    margin={{
                      top: 5,
                      right: 30,
                      left: 0,
                      bottom: 5,
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="time" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line
                      type="monotone"
                      dataKey="peOI"
                      stroke="#2196F3"
                      name="PE OI"
                      dot={false}
                    />
                    <Line
                      type="monotone"
                      dataKey="peOIChange"
                      stroke="#006E1C"
                      name="PE OIchg"
                      dot={false}
                    />
                    <Line
                      type="monotone"
                      dataKey="peLtp"
                      stroke="#F00000"
                      name="PE LTP"
                      dot={false}
                    />
                  </LineChart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ======== OI Percentage Graph-1 popup ======== */}
      <div
        className="modal fade"
        id="oipercentage1Model"
        tabIndex={-1}
        aria-labelledby="oioipercentage1ModelLabel"
        aria-hidden="true "
      >
        <div className="modal-dialog ai-chart modal-dialog-centered">
          <div className="modal-content modal-bg-light-blue">
            <div className="modal-header">
              <h5 className="modal-title" id="disclaimerModelLabel">
                oipercentage1 Graph
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="oi-chart-btn-inner">
                <ul className="list-unstyled d-flex justify-content-center align-items-center">
                  <li>
                    <button>
                      <span />
                      Volume
                    </button>
                  </li>
                  <li>
                    <button>
                      <span className="oi-chart-wine" />
                      OI
                    </button>
                  </li>
                  <li>
                    <button>
                      <span className="oi-chart-green" />
                      OI Change
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="pills-home"
                  role="tabpanel"
                  aria-labelledby="pills-home-tab"
                >
                  <div className="ai-chart-img">
                    {greekChainData.length > 0 ? (
                      <OptionChainChart data={greekChainData} />
                    ) : (
                      <p></p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="pills-home"
                role="tabpanel"
                aria-labelledby="pills-home-tab"
              >
                <div className="ai-chart-img">
                  <LineChart
                    width={1300}
                    height={500}
                    data={processedData}
                    margin={{
                      top: 5,
                      right: 30,
                      left: 20,
                      bottom: 5,
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="LastTradeTime" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line
                      type="monotone"
                      dataKey="OpenInterest"
                      stroke="#9B27AF"
                      dot={false}
                    />
                    <Line
                      type="monotone"
                      dataKey="TotalQtyTraded"
                      stroke="#0000FF"
                      dot={false}
                    />
                    <Line
                      type="monotone"
                      dataKey="OpenInterestChange"
                      stroke="#006E1C"
                      dot={false}
                    />
                  </LineChart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ======== Combined Price Chart IV- popup ======== */}
      <div
        className="modal fade "
        id="CombinedpriceModel"
        tabIndex={-1}
        aria-labelledby="CombinedpriceModelLabel"
        aria-hidden="true "
      >
        <div className="modal-dialog ai-chart modal-dialog-centered">
          <div className="modal-content modal-bg-light-blue">
            <div className="modal-header">
              <h5 className="modal-title" id="CombinedpriceModel">
                Combined Price Chart
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="oi-chart-btn-inner">
                <ul className="list-unstyled d-flex justify-content-center align-items-center">
                  <li>
                    {" "}
                    <button>
                      {" "}
                      <span className="oi-chart-lite-blue" />
                      Combined Price
                    </button>
                  </li>
                  <li>
                    {" "}
                    <button>
                      {" "}
                      <span className="oi-chart-green" />
                      CE Price
                    </button>
                  </li>
                  <li>
                    {" "}
                    <button>
                      {" "}
                      <span className="oi-chart-red" />
                      PE Price
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="pills-home"
                role="tabpanel"
                aria-labelledby="pills-home-tab"
              >
                <div className="ai-chart-img">
                  <img src="img/combined-price-chart-iv.svg" alt="chart" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ======== Combined Price Chart IV-1 popup ======== */}
      <div
        className="modal fade "
        id="futureBuildupModel"
        tabIndex={-1}
        aria-labelledby="futureBuildupModelLabel"
        aria-hidden="true "
      >
        <div className="modal-dialog ai-chart modal-dialog-centered">
          <div className="modal-content modal-bg-light-blue">
            <div className="modal-header">
              <h5 className="modal-title" id="futureBuildupModel">
                Future Buildup: Nifty
              </h5>
              <button
                type="button"
                className="info-table"
                data-bs-dismiss="modal"
                data-bs-target="#futureBuildupinfoModel"
              >
                <i style={{ fontSize: "24px" }} className="fa fa-info-circle" />
              </button>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="oi-chart-btn-inner">
                <ul className="list-unstyled d-flex justify-content-center align-items-center">
                  <li>
                    {" "}
                    <button>
                      {" "}
                      <span className="oi-chart-lite-blue" />
                      Future Price
                    </button>
                  </li>
                  <li>
                    {" "}
                    <button>
                      {" "}
                      <span className="oi-chart-wine" />
                      Future OI Price
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="pills-home"
                role="tabpanel"
                aria-labelledby="pills-home-tab"
              >
                <div className="ai-chart-img">
                  <img src="img/combined-price-chart-iv-1.svg" alt="chart" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ======== info-table popup ======== */}
      <div
        className="modal fade "
        id="futureBuildupinfoModel"
        tabIndex={-1}
        aria-labelledby="futureBuildupinfoModelLabel"
        aria-hidden="true "
      >
        <div className="modal-dialog ai-chart modal-dialog-centered">
          <div className="modal-content modal-bg-light-blue">
            <div className="modal-body">
              <div className="oi-chart-btn-inner  ">
                <table className="info-table  w-100 ">
                  <tbody>
                    <tr className="info-table-row ">
                      <th className="info-table-heading">Price</th>
                      <th className="info-table-heading">OI or OI CHNG</th>
                      <th className="info-table-heading">Result</th>
                      <th className="info-table-heading">Meaning</th>
                      <th className="info-table-heading">Option Trade</th>
                    </tr>
                    <tr className="info-table-row-1">
                      <td className="info-table-data">Up</td>
                      <td className="info-table-data">Up</td>
                      <td className="info-table-data">Long Buildup</td>
                      <td className="info-table-data">Strong Bullish</td>
                      <td className="info-table-data">CE Buy</td>
                    </tr>
                    <tr className="info-table-row-1">
                      <td className="info-table-data">Up</td>
                      <td className="info-table-data">Up</td>
                      <td className="info-table-data">Long Buildup</td>
                      <td className="info-table-data">Strong Bullish</td>
                      <td className="info-table-data">CE Buy</td>
                    </tr>
                    <tr className="info-table-row-1">
                      <td className="info-table-data">Up</td>
                      <td className="info-table-data">Up</td>
                      <td className="info-table-data">Long Buildup</td>
                      <td className="info-table-data">Strong Bullish</td>
                      <td className="info-table-data">CE Buy</td>
                    </tr>
                    <tr className="info-table-row-1">
                      <td className="info-table-data">Up</td>
                      <td className="info-table-data">Up</td>
                      <td className="info-table-data">Long Buildup</td>
                      <td className="info-table-data">Strong Bullish</td>
                      <td className="info-table-data">CE Buy</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ======== volume-chart popup ======== */}
      <div
        className="modal fade "
        id="volumeChartModel"
        tabIndex={-1}
        aria-labelledby="volumeChartModelLabel"
        aria-hidden="true "
      >
        <div className="modal-dialog  modal-dialog-centered">
          <div className="modal-content modal-bg-light-blue">
            <div className="modal-header">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="volume-chart-inner  ">
                {/* <h3><strong>Possible Reversal For</strong> : 21500</h3> */}
                <h3>
                  <strong>Possible Reversal For</strong> : {selectedStrikePrice}
                </h3>
                <h4>
                  <strong>Resistance:</strong> {(resistance).toFixed(2)}
                  <button
                    className="volume-copy-btn"
                    data-bs-target="#valueCopyModel"
                    data-bs-dismiss="modal"
                  >
                    <i className="fa fa-clone" aria-hidden="true" />
                  </button>{" "}
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade "
        id="volumeChartModel12"
        tabIndex={-1}
        aria-labelledby="volumeChartModel12Label"
        aria-hidden="true "
      >
        <div className="modal-dialog  modal-dialog-centered">
          <div className="modal-content modal-bg-light-blue">
            <div className="modal-header">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="volume-chart-inner  ">
                {/* <h3><strong>Possible Reversal For</strong> : 21500</h3> */}
                <h3>
                  <strong>Possible Reversal For</strong> : {selectedStrikePrice}
                </h3>
                <h4>
                  <strong>Support:</strong> {(support).toFixed(2)}
                  <button
                    className="volume-copy-btn"
                    data-bs-target="#valueCopyModel"
                    data-bs-dismiss="modal"
                  >
                    <i className="fa fa-clone" aria-hidden="true" />
                  </button>{" "}
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ======== volume-chart-1 popup ======== */}
      <div
        className="modal fade valueCopy"
        id="valueCopyModel"
        tabIndex={-1}
        aria-labelledby="valueCopyModelLabel"
        aria-hidden="true "
      >
        <div className="modal-dialog  modal-dialog-centered">
          <div className="modal-content modal-bg-light-blue">
            <div className="modal-header">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="volume-chart-inner volume-chart-1  ">
                <h3>Value Copied to clipboard</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ======== LTP Calculator popup ======== */}
      <div
        className="modal fade "
        id="LPTcalculatorModel"
        tabIndex={-1}
        aria-labelledby="LPTcalculatorModelLabel"
        aria-hidden="true "
      >
        <div className="modal-dialog  modal-dialog-centered">
          <div className="modal-content modal-bg-light-blue">
            <div className="modal-header">
              <h5 className="modal-title" id="LPTcalculatorModelLabel">
                LTP calculator 22000 CE
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <input
                type="text"
                placeholder="Target spot price"
                className="ltp-calculator-field"
              />
              <div className="volume-chart-inner ltp-calculator-content ">
                <h3>
                  <strong>Buy Price:</strong> - 3216.09
                </h3>
                <h4>
                  <strong>SL: </strong> - 3219.09
                </h4>
                <h5>
                  <strong>Target: </strong> - 6527.25
                </h5>
                <p>
                  This is a rough estimate, calculation is based on delta.
                  Please use your own judgement and do not trade based on this
                  alone.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ======== free-user popup ======== */}
      <div
        className="modal fade "
        id="freeUserModel"
        tabIndex={-1}
        aria-labelledby="freeUserModelLabel"
        aria-hidden="true "
      >
        <div className="modal-dialog  modal-dialog-centered">
          <div className="modal-content modal-bg-light-blue">
            <div className="modal-header">
              <h5 className="modal-title" id="freeUserModelLabel">
                Upgrade to Pro Plan for <br />
                faster data update
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="volume-chart-inner  ">
                <div className="free-user-content">
                  <p>As a free user, you will get delayed data by 3 minutes.</p>
                  <p>
                    Upgrade to Pro Plan to get faster data updates and <br />
                    access to all features.
                  </p>
                </div>
                <div className="free-user-check">
                  <h2>
                    <i
                      style={{ color: "#25D366" }}
                      className="fa fa-check-circle-o"
                      aria-hidden="true"
                    >
                      {" "}
                    </i>{" "}
                    Fast data updates
                  </h2>
                  <h2>
                    <i
                      style={{ color: "#25D366" }}
                      className="fa fa-check-circle-o"
                      aria-hidden="true"
                    >
                      {" "}
                    </i>{" "}
                    Ads free experience
                  </h2>
                  <h2>
                    <i
                      style={{ color: "#25D366" }}
                      className="fa fa-check-circle-o"
                      aria-hidden="true"
                    >
                      {" "}
                    </i>{" "}
                    Access to all features
                  </h2>
                  <h2>
                    <i
                      style={{ color: "#25D366" }}
                      className="fa fa-check-circle-o"
                      aria-hidden="true"
                    >
                      {" "}
                    </i>{" "}
                    Access to all future features
                  </h2>
                  <h2>
                    <i
                      style={{ color: "#25D366" }}
                      className="fa fa-check-circle-o"
                      aria-hidden="true"
                    >
                      {" "}
                    </i>{" "}
                    Premium support
                  </h2>
                </div>
                <div className="free-user-btn-content d-flex justify-content-center align-items-center">
                  <button className="free-user-btn me-3">
                    Continue as free user
                  </button>
                  <button className="free-user-btn btn-red">
                    Subscribe to Pro Plan
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ======== Search Nifty popup ======== */}
      <div
        className="modal fade"
        id="searchNiftyModel"
        tabIndex={-1}
        aria-labelledby="searchNiftyModelLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content modal-bg-light-green">
            <div className="modal-body py-4 px-4">
              <form className="search-field-container">
                <div className="form-input">
                  <input
                    type="search"
                    name="Search Nifty"
                    className="form-control"
                    placeholder="Search Stock/Index"
                  />
                </div>
              </form>
              <div className="nifty-index-list">
                <ul className="list-unstyled">
                  <li>
                    <button>Banknifty</button>
                  </li>
                  <li>
                    <button>Finnifty</button>
                  </li>
                  <li>
                    <button>Nifty_Mid_Select</button>
                  </li>
                  <li>
                    <button>Nifty</button>
                  </li>
                  <li>
                    <button>Naturalgas</button>
                  </li>
                  <li>
                    <button>Crudeoil</button>
                  </li>
                  <li>
                    <button>Usdinr</button>
                  </li>
                  <li>
                    <button>Sensex</button>
                  </li>
                  <li>
                    <button>bankex</button>
                  </li>
                  <li>
                    <button>Aartiind</button>
                  </li>
                  <li>
                    <button>Sensex</button>
                  </li>
                  <li>
                    <button>bankex</button>
                  </li>
                  <li>
                    <button>Aartiind</button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ======== Update Profile popup ======== */}
      <div
        className="modal fade"
        id="updateModel"
        tabIndex={-1}
        aria-labelledby="updateModelLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content modal-bg-light-blue">
            <div className="modal-header">
              <h5 className="modal-title" id="disclaimerModelLabel">
                Update Profile
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body py-4 px-5">
              <div className="header-logo text-center">
                <a href="#">
                  <img src="img/header-logo.svg" alt="logo" />
                </a>
              </div>
              <div className="login-form-outer">
                <form>
                  <div className="form-input mb-3">
                    <input
                      type="text"
                      name="Name"
                      className="form-control"
                      placeholder="Name"
                    />
                  </div>
                  <div className="form-input mb-3">
                    <input
                      type="text"
                      name="State"
                      className="form-control"
                      placeholder="State"
                    />
                  </div>
                  <div className="form-input mb-3">
                    <input
                      type="text"
                      name="District"
                      className="form-control"
                      placeholder="District"
                    />
                  </div>
                  <div className="form-input mb-3">
                    <input
                      type="text"
                      name="City"
                      className="form-control"
                      placeholder="City"
                    />
                  </div>
                  <div className="form-input mb-3">
                    <input
                      type="text"
                      name="Phone"
                      className="form-control"
                      placeholder="Phone"
                    />
                  </div>
                  <div className="update-btn-outer">
                    <button
                      type="button"
                      className="site-btn btn-blue-o"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="update-btn site-btn btn-blue"
                    >
                      Update
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ======== Delete Account Warning popup ======== */}
      <div
        className="modal fade"
        id="deleteACModel"
        tabIndex={-1}
        aria-labelledby="deleteACModelLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content modal-bg-light-green">
            <div className="modal-body py-4 px-5 text-center">
              <h4>Warning !!</h4>
              <p className="desc my-2">
                Are you sure you want to delete your account?
              </p>
              <p className="desc mb-2">This action cannot be done.</p>
              <p className="desc mb-2">All your data will be deleted.</p>
              <div className="donate-btn-grp text-center py-4">
                <button
                  className="site-btn btn-blue delete-btn"
                  data-bs-toggle="modal"
                  data-bs-target="#deleteACModel"
                >
                  Cancel
                </button>
                <button className="site-btn btn-red delete-btn">
                  Delete Account
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ======== Notification popup ======== */}
      <div
        className="modal fade"
        id="notificationModel"
        tabIndex={-1}
        aria-labelledby="notificationModelLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content modal-bg-light-blue">
            <div className="modal-header">
              <h5 className="modal-title" id="notificationModelLabel">
                Notification Setting
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="notification-functionalty-outer popup-list">
                <ul className="list-unstyled">
                  <li>
                    <div className="popup-list-title">
                      <span>
                        <img src="img/stock-ticker.svg" alt="icon" />
                      </span>
                      <span>Stocks</span>
                    </div>
                    <div className="toggle-status">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input stocks"
                          type="checkbox"
                          id="flexSwitchCheckChecked"
                          defaultChecked
                        />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="popup-list-title">
                      <span>
                        <img src="img/data-collection.svg" alt="icon" />
                      </span>
                      <span>Indices</span>
                    </div>
                    <div className="toggle-status">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input indices"
                          type="checkbox"
                          id="flexSwitchCheckChecked"
                          defaultChecked
                        />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="popup-list-title">
                      <span>
                        <img src="img/currency.svg" alt="icon" />
                      </span>
                      <span>Currency</span>
                    </div>
                    <div className="toggle-status">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input currency"
                          type="checkbox"
                          id="flexSwitchCheckChecked"
                          defaultChecked
                        />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="popup-list-title">
                      <span>
                        <img src="img/stock_mcx.svg" alt="icon" />
                      </span>
                      <span>MCX</span>
                    </div>
                    <div className="toggle-status">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input mcx"
                          type="checkbox"
                          id="flexSwitchCheckChecked"
                          defaultChecked
                        />
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ======== Disclaimer popup ======== */}
      <div
        className="modal fade"
        id="disclaimerModel"
        tabIndex={-1}
        aria-labelledby="disclaimerModelLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content modal-bg-light-blue">
            <div className="modal-header">
              <h5 className="modal-title" id="disclaimerModelLabel">
                Disclaimer
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="disclaimer-functionalty-outer">
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled it to make a type
                  specimen book. It has survived not only five centuries, but
                  also the leap into electronic typesetting, remaining
                  essentially unchanged. It was popularised in the 1960s with
                  the release of Letraset sheets containing Lorem Ipsum
                  passages, and more recently with desktop publishing software
                  like Aldus PageMaker including versions of Lorem Ipsum
                  <br />
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled it to make a type
                  specimen book. It has survived not only five centuries, but
                  also the leap into electronic typesetting, remaining
                  essentially unchanged.{" "}
                </p>
                <div className="modal-footer mt-3">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary site-btn"
                    data-bs-dismiss="modal"
                  >
                    Accept &amp; Continue
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ======== Login popup ======== */}
      <div
        className="modal fade"
        id="loginModel"
        tabIndex={-1}
        aria-labelledby="loginModelLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content modal-bg-light-blue">
            <div className="modal-body py-4 px-5">
              <div className="header-logo text-center">
                <a href="#">
                  <img src="img/header-logo.svg" alt="logo" />
                </a>
              </div>
              <div className="login-title text-center my-3">
                <h4>Login</h4>
                <h5>
                  Welcome to Option Trading Wala <br /> Please Login to Continue
                </h5>
              </div>
              <div className="login-form-outer">
                <form>
                  <div className="form-input mb-3">
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label"
                    >
                      Email / Phone No
                    </label>
                    <input
                      type="text"
                      name="Email or Phone No"
                      className="form-control"
                      placeholder="Enter Email or Phone No."
                    />
                  </div>
                  <div className="form-input mb-3">
                    <label
                      htmlFor="exampleFormControlInput2"
                      className="form-label"
                    >
                      Password
                    </label>
                    <input
                      type="password"
                      name="Password"
                      className="form-control"
                      placeholder="Enter Password"
                    />
                  </div>
                  <div className="otp-outer text-center">
                    <p>Enter your OTP</p>
                    <div className="otp-code-inner my-2">
                      <input type="text" name="otp-code-1" maxLength={1} />
                      <input type="text" name="otp-code-2" maxLength={1} />
                      <input type="text" name="otp-code-3" maxLength={1} />
                      <input type="text" name="otp-code-4" maxLength={1} />
                      <input type="text" name="otp-code-5" maxLength={1} />
                      <input type="text" name="otp-code-6" maxLength={1} />
                    </div>
                    <p>
                      <a href="#" className="text-success">
                        Resend OTP In
                      </a>
                      <span className="otp-time ms-2">00:28</span>
                    </p>
                  </div>
                  <button type="submit" className="submit-btn">
                    Login
                  </button>
                </form>
                <div className="signup-and-forgot-pswd d-flex justify-content-between mt-2">
                  <a href="#" className="text-danger">
                    SignUp
                  </a>
                  <a href="#">Forget Password?</a>
                </div>
                <div className="privacy-policy-and-terms-&-service text-center mt-4">
                  <p>
                    By Clicking on login you agree to <br />
                    <a href="#">Privacy Policy</a> &amp;{" "}
                    <a href="#">Terms &amp; Service</a>
                  </p>
                </div>
                <div className="google-sign-in text-center">
                  <button>
                    <img src="img/google-logo.svg" alt="google-logo" />
                    Sign in with Google
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ======== Strike price popup ======== */}
      <div
        className="modal fade"
        id="strikePriceModel"
        tabIndex={-1}
        aria-labelledby="strikePriceModelLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content modal-bg-light-blue">
            <div className="modal-header">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="volume-chart-inner">
                <h5>Elastic Ends Of Strike Price</h5>
                <br />
                <h2>
                  <strong>{selectedStrikePrice}</strong>
                </h2>
                <div className="modal-info-section">
                  <ul
                    className="nav nav-tabs justify-content-center"
                    id="myTab"
                    role="tablist"
                  >
                    <li className="nav-item">
                      <a
                        className="nav-link active"
                        id="home-tab"
                        data-bs-toggle="tab"
                        href="#home"
                        role="tab"
                        aria-controls="home"
                        aria-selected="true"
                      >
                        SPOT
                      </a>
                    </li>
                    <li className="nav-item">
                      <a

                        className="nav-link"
                        id="profile-tab"
                        data-bs-toggle="tab"
                        href="#profile"
                        role="tab"
                        aria-controls="profile"
                        aria-selected="false"
                      >
                        FUTURE
                      </a>
                    </li>
                    {/* <li className="nav-item">
                      <a
                        className="nav-link"
                        id="contact-tab"
                        data-bs-toggle="tab"
                        href="#contact"
                        role="tab"
                        aria-controls="contact"
                        aria-selected="false"
                      >
                        WEEKLY FUTURE
                      </a>
                    </li> */}
                  </ul>
                </div>

                <div className="tab-content" id="myTabContent">
                  <div
                    className="tab-pane fade show active"
                    id="home"
                    role="tabpanel"
                    aria-labelledby="home-tab"
                  >
                    <div className="modal-info-section">
                      <h5>Average Elastic Ends(9:30 AM)</h5>
                      <h2>
                        <span className="text-danger">Resistance:</span>{" "}
                        {resistance2.toFixed(2)}
                        <button
                          className="volume-copy-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#valueCopyModel"
                        >
                          <i className="fa fa-clone" aria-hidden="true"></i>
                        </button>
                      </h2>
                      <h2>
                        <span className="text-success">Support:</span>{" "}
                        {support2.toFixed(2)}
                        <button
                          className="volume-copy-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#valueCopyModel"
                        >
                          <i className="fa fa-clone" aria-hidden="true"></i>
                        </button>
                      </h2>
                    </div>
                    <div className="modal-info-section">
                      <h5>Current Elastic Ends</h5>
                      <h2>
                        <span className="text-danger">Resistance:</span>{" "}
                        {resistance.toFixed(2)}
                        <button
                          className="volume-copy-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#valueCopyModel"
                        >
                          <i className="fa fa-clone" aria-hidden="true"></i>
                        </button>
                      </h2>
                      <h2>
                        <span className="text-success">Support:</span>{support.toFixed(2)}
                        <button
                          className="volume-copy-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#valueCopyModel"
                        >
                          <i className="fa fa-clone" aria-hidden="true"></i>
                        </button>
                      </h2>
                    </div>
                  </div>

                  <div
                    className="tab-pane fade"
                    id="profile"
                    role="tabpanel"
                    aria-labelledby="profile-tab"
                  >
                    <div className="modal-info-section">
                      <h5>Average Elastic Ends(9:30 AM)</h5>
                      <h2>
                        <span className="text-danger">Resistance:</span>{futureResistance2.toFixed(2)}

                        <button
                          className="volume-copy-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#valueCopyModel"
                        >
                          <i className="fa fa-clone" aria-hidden="true"></i>
                        </button>
                      </h2>
                      <h2>
                        <span className="text-success">Support:</span>{futureSupport2.toFixed(2)}
                        <button
                          className="volume-copy-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#valueCopyModel"
                        >
                          <i className="fa fa-clone" aria-hidden="true"></i>
                        </button>
                      </h2>
                    </div>
                    <div className="modal-info-section">
                      <h5>Current Elastic Ends</h5>
                      <h2>
                        <span className="text-danger">Resistance:</span>{futureResistance.toFixed(2)}
                        <button
                          className="volume-copy-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#valueCopyModel"
                        >
                          <i className="fa fa-clone" aria-hidden="true"></i>
                        </button>
                      </h2>
                      <h2>
                        <span className="text-success">Support:</span> {futureSupport.toFixed(2)}
                        <button
                          className="volume-copy-btn"
                          data-bs-toggle="modal"
                          data-bs-target="#valueCopyModel"
                        >
                          <i className="fa fa-clone" aria-hidden="true"></i>
                        </button>
                      </h2>
                    </div>
                  </div>
                 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*====== Call vs Put OI===== */}
    
      {/* ======== Signup popup ======== */}
      <div
        className="modal fade"
        id="signupModel"
        tabIndex={-1}
        aria-labelledby="signupModelLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content modal-bg-light-blue">
            <div className="modal-body py-4 px-5">
              <div className="header-logo text-center">
                <a href="#">
                  <img src="img/header-logo.svg" alt="logo" />
                </a>
              </div>
              <div className="login-title text-center my-3">
                <h4>Register</h4>
                <h5>
                  Welcome to Option Trading Wala <br /> Please Register to
                  Continue
                </h5>
              </div>
              <div className="login-form-outer">
                <form>
                  <div className="form-input mb-3">
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label"
                    >
                      Name
                    </label>
                    <input
                      type="text"
                      name="Name"
                      className="form-control"
                      placeholder="Enter Name"
                    />
                  </div>
                  <div className="form-input mb-3">
                    <label
                      htmlFor="exampleFormControlInput2"
                      className="form-label"
                    >
                      Email
                    </label>
                    <input
                      type="email"
                      name="Email"
                      className="form-control"
                      placeholder="Enter Email"
                    />
                  </div>
                  <div className="form-input mb-3">
                    <label
                      htmlFor="exampleFormControlInput3"
                      className="form-label"
                    >
                      Phone No.
                    </label>
                    <input
                      type="tel"
                      name="phone no."
                      className="form-control"
                      placeholder="Enter Phone No."
                    />
                  </div>
                  <div className="form-input mb-3">
                    <label
                      htmlFor="exampleFormControlInput4"
                      className="form-label"
                    >
                      Password
                    </label>
                    <input
                      type="password"
                      name="Password"
                      className="form-control"
                      placeholder="Enter Password"
                    />
                  </div>
                  <div className="otp-outer text-center">
                    <p>Enter your OTP</p>
                    <div className="otp-code-inner my-2">
                      <input type="text" name="otp-code-1" maxLength={1} />
                      <input type="text" name="otp-code-2" maxLength={1} />
                      <input type="text" name="otp-code-3" maxLength={1} />
                      <input type="text" name="otp-code-4" maxLength={1} />
                      <input type="text" name="otp-code-5" maxLength={1} />
                      <input type="text" name="otp-code-6" maxLength={1} />
                    </div>
                    <p>
                      <a href="#" className="text-success">
                        Resend OTP In
                      </a>
                      <span className="otp-time ms-2">00:28</span>
                    </p>
                  </div>
                  <button type="submit" className="submit-btn">
                    Login
                  </button>
                </form>
                <div className="signup-and-forgot-pswd d-flex justify-content-center mt-2">
                  <p>
                    Already have an Account?{" "}
                    <a href="#" className="text-danger">
                      Login
                    </a>
                  </p>
                </div>
                <div className="privacy-policy-and-terms-&-service text-center mt-4">
                  <p>
                    By Clicking on login you agree to <br />
                    <a href="#">Privacy Policy</a> &amp;{" "}
                    <a href="#">Terms &amp; Service</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Optionchain;
